import { type ReactNode, createContext, useContext, useMemo } from "react";
import type { useDRYP } from "./logics";

const Context = createContext<ReturnType<typeof useDRYP> | undefined>(undefined);

export const useDRYPContext = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useDRYPContext must be within DRMPProvider");
  }

  return context;
};

type IDRYP = ReturnType<typeof useDRYP> & {
  children: ReactNode;
};

export const DRYPProvider = ({ children, ...props }: IDRYP) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const value = useMemo(
    () => props,
    [
      props.selectRange,
      props.handleMouseEnter,
      props.handleMouseLeave,
      props.handleSelect,
      props.isSelected,
      props.isBetween,
    ]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
